module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.chart) ? _c('pie-chart', {
    attrs: {
      "data": _vm.chart.data,
      "donut": true,
      "legend": _vm.showLegend ? _vm.posLegend : null,
      "colors": _vm.chart.colors
    }
  }) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-17d3b010"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/charts/SitesChart.vue
// module id = 1439
// module chunks = 0